import { render, staticRenderFns } from "./KoinDefaultLayout.vue?vue&type=template&id=f7727cf0&scoped=true"
import script from "./KoinDefaultLayout.vue?vue&type=script&lang=js"
export * from "./KoinDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7727cf0",
  null
  
)

export default component.exports